module.exports = __webpack_public_path__ + "static/img/1.b81dcae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/zh/1.png
// module id = 3T/K
// module chunks = 0